module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.item.hidden) ? _c('dy-item-wrap', {
    attrs: {
      "item": _vm.item
    }
  }, [_c('el-row', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_c('el-checkbox', _vm._g(_vm._b({
    attrs: {
      "disabled": _vm.item.disabled || false
    }
  }, 'el-checkbox', _vm.$attrs, false), _vm.$listeners))], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34d759e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/widgets/BooleanWidget.vue
// module id = 716
// module chunks = 20